import { type FC } from 'react';

import { useListingContext } from '@/microfrontends/listing/shared/context/ListingContext';
import { useInitCardApi } from '@/microfrontends/listing/shared/hooks/useInitCardApi';

import { CardsWithAdsContainer } from './CardsWithAdsContainer';

export const ListingCardsContainer: FC = () => {
  const {
    adfox,
    listingProperties: { dealType },
    offers,
  } = useListingContext();

  const initCardApi = useInitCardApi();

  return <CardsWithAdsContainer adfox={adfox} dealType={dealType} initCardApi={initCardApi} offers={offers} />;
};
